export default "__VITE_ASSET__L0daKp9H__"